import React from 'react';
import { Trans } from '@lingui/react';

export default {
    Unassign: <Trans>Unassign</Trans>,
    Back: <Trans>Back</Trans>,
    Download: <Trans>Download sign-in cards</Trans>,
    Downloading: <Trans>Downloading</Trans>
};



// WEBPACK FOOTER //
// ./components/page-footer/page-footer-text.js